// ** React Imports
import { lazy } from 'react'
import { Navigate } from 'react-router-dom'

const Chat = lazy(() => import('../../views/apps/chat'))
const Todo = lazy(() => import('../../views/apps/todo'))
const Email = lazy(() => import('../../views/apps/email'))
const Calendar = lazy(() => import('../../views/apps/calendar'))

const InvoiceAdd = lazy(() => import('../../views/apps/invoice/add'))
const InvoiceList = lazy(() => import('../../views/apps/invoice/list'))
const InvoiceEdit = lazy(() => import('../../views/apps/invoice/edit'))
const InvoicePrint = lazy(() => import('../../views/apps/invoice/print'))
const InvoicePreview = lazy(() => import('../../views/apps/invoice/preview'))

const EcommerceShop = lazy(() => import('../../views/apps/ecommerce/shop'))
const EcommerceDetail = lazy(() => import('../../views/apps/ecommerce/detail'))
const EcommerceWishlist = lazy(() => import('../../views/apps/ecommerce/wishlist'))
const EcommerceCheckout = lazy(() => import('../../views/apps/ecommerce/checkout'))

const UserList = lazy(() => import('../../views/apps/user/list'))
const PasswordReset = lazy(() => import('../../views/apps/user/reset-password/PasswordReset'))
const UserPasswordReset = lazy(() => import('../../views/apps/user/reset-password/UserPasswordReset'))
const UserView = lazy(() => import('../../views/apps/user/view'))

const Roles = lazy(() => import('../../views/apps/roles-permissions/roles'))
const Permissions = lazy(() => import('../../views/apps/roles-permissions/permissions'))

const AppRoutes = [
  {
    element: <Email />,
    path: '/apps/email',
    meta: {
      appLayout: true,
      className: 'email-application',
      publicRoute: true
    }
  },
  {
    element: <Email />,
    path: '/apps/email/:folder',
    meta: {
      appLayout: true,
      className: 'email-application',
      publicRoute: true
    }
  },
  {
    element: <Email />,
    path: '/apps/email/label/:label',
    meta: {
      appLayout: true,
      className: 'email-application',
      publicRoute: true
    }
  },
  {
    element: <Email />,
    path: '/apps/email/:filter',
    meta: {
      publicRoute: true
    }
  },
  {
    path: '/apps/chat',
    element: <Chat />,
    meta: {
      appLayout: true,
      className: 'chat-application',
      publicRoute: true
    }
  },
  {
    element: <Todo />,
    path: '/apps/todo',
    meta: {
      appLayout: true,
      className: 'todo-application'
    }
  },
  {
    element: <Todo />,
    path: '/apps/todo/:filter',
    meta: {
      appLayout: true,
      className: 'todo-application'
    }
  },
  {
    element: <Todo />,
    path: '/apps/todo/tag/:tag',
    meta: {
      appLayout: true,
      className: 'todo-application'
    }
  },
  {
    element: <Calendar />,
    path: '/apps/calendar'
  },
  {
    element: <InvoiceList />,
    path: '/apps/invoice/list',
    meta: {
      publicRoute: true
    }
  },
  {
    element: <InvoicePreview />,
    path: '/apps/invoice/preview/:id',
    meta: {
      publicRoute: true
    }
  },
  {
    path: '/apps/invoice/preview',
    element: <Navigate to="/apps/invoice/preview/4987" />,
    meta: {
      publicRoute: true
    }
  },
  {
    element: <InvoiceEdit />,
    path: '/apps/invoice/edit/:id',
    meta: {
      publicRoute: true
    }
  },
  {
    path: '/apps/invoice/edit',
    element: <Navigate to="/apps/invoice/edit/4987" />,
    meta: {
      publicRoute: true
    }
  },
  {
    element: <InvoiceAdd />,
    path: '/apps/invoice/add'
  },
  {
    path: '/apps/invoice/print',
    element: <InvoicePrint />,
    meta: {
      layout: 'blank'
    }
  },
  {
    element: <EcommerceShop />,
    path: '/apps/ecommerce/shop',
    meta: {
      className: 'ecommerce-application'
    }
  },
  {
    element: <EcommerceWishlist />,
    path: '/apps/ecommerce/wishlist',
    meta: {
      className: 'ecommerce-application'
    }
  },
  {
    path: '/apps/ecommerce/product-detail',
    element: <Navigate to="/apps/ecommerce/product-detail/apple-i-phone-11-64-gb-black-26" />,
    meta: {
      className: 'ecommerce-application'
    }
  },
  {
    path: '/apps/ecommerce/product-detail/:product',
    element: <EcommerceDetail />,
    meta: {
      className: 'ecommerce-application'
    }
  },
  {
    path: '/apps/ecommerce/checkout',
    element: <EcommerceCheckout />,
    meta: {
      className: 'ecommerce-application'
    }
  },
  {
    element: <UserList />,
    path: '/apps/user/list',
    meta: {
      layout: 'vertical',
      action: 'manage',
      resource: 'User'
    }
  },

  {
    element: <PasswordReset />,
    path: '/user/password-reset',
    meta: {
      layout: 'vertical',
      action: 'manage',
      resource: 'Password'
    }
  },
  {
    element: <UserPasswordReset />,
    path: '/apps/user/list/:id/password-reset',

    meta: {
      layout: 'vertical',
      action: 'manage',
      resource: 'User'
    }
  },
  {
    path: '/apps/user/view',
    element: <Navigate to="/apps/user/view/1" />,
    meta: {
      action: 'read',
      resource: 'User'
    }
  },
  {
    element: <UserView />,
    path: '/apps/user/list/view/:id',
    meta: {
      layout: 'vertical',
      action: 'read',
      resource: 'User'
    }
  },
  {
    element: <Roles />,
    path: '/roles',
    meta: {
      layout: 'vertical',
      action: 'manage',
      resource: 'Role'
    }
  },
  {
    element: <Permissions />,
    path: '/apps/permissions',
    meta: {
      layout: 'vertical',
      action: 'manage',
      resource: 'Role'
    }
  }
]

export default AppRoutes
